import React, { useEffect } from "react";
import logo from "../images/logo.png";
import "./LoadingPage.css";
import ProgressBar from "../components/ProgressBar";
import { useNavigate } from "react-router-dom";
import { PiAppleLogoThin } from "react-icons/pi";
import { IconContext } from "react-icons";

function LoadingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/welcome");
    }, 8000);
  }, []);
  return (
    <div style={{ backgroundColor: "yellow" }} className="main">
      <div className="progress-bar-container">
        {/* <img src={logo} alt='Logo' className='logo' height={'20px'} width={'20px'}/> */}
        <IconContext.Provider value={{ color: "white", size: "10em" }}>
          <PiAppleLogoThin className="react-icons" />
        </IconContext.Provider>
        <ProgressBar />
      </div>
    </div>
  );
}

export default LoadingPage;
